import { useApi } from '@gravitate-js/the-armory'
import { useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'
import type { BookType } from './types'
import type { RecentActivityResponse } from './types/dashboard'

/**
 * Hook for fetching recent activity data
 */
export const useRecentActivity = (costRevenue: BookType) => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  return useQuery<RecentActivityResponse[], Error>({
    queryKey: ['recentActivity', costRevenue],
    queryFn: async () => {
      const data = await api.post<RecentActivityResponse[]>('freight/invoice/recent_activity', undefined, {
        queryParams: new URLSearchParams({
          book_type: costRevenue,
        }),
      })

      return data
    },
    refetchOnWindowFocus: false,
    retry: 1,
  })
}
